import React, {useRef, useState} from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";
import {useOnClickOutside} from "@utils";

const AreaMenu: React.FC<{}> = () => {
  const ref = useRef();
  const [isAreaMenuOpen, setIsAreaMenuOpen] = useState(false);

  useOnClickOutside(ref, () => setIsAreaMenuOpen(false));

  function openAreaMenu () {
    setIsAreaMenuOpen(true);
  }

  return (
    <AreaMenuContainer ref={ref} onClick={openAreaMenu}>
      SHOP TESTS
      {isAreaMenuOpen && (
        <AreaMenuPopup>
          <AreasMenuPopupLink href="/goal/weight-management">WEIGHT MANAGEMENT</AreasMenuPopupLink>
          <AreasMenuPopupLink href="/goal/fatigue">FATIGUE</AreasMenuPopupLink>
          <AreasMenuPopupLink href="/goal/anxiety-depression">ANXIETY & DEPRESSION</AreasMenuPopupLink>
          <AreasMenuPopupLink href="/goal/womens-health">HORMONAL IMBALANCES</AreasMenuPopupLink>
          <AreasMenuPopupLink href="/all-goals">SHOP ALL</AreasMenuPopupLink>
        </AreaMenuPopup>
      )}
    </AreaMenuContainer>
  );
};

export default AreaMenu;

const AreaMenuContainer = styled.div`
  position: relative;
  padding: 8px;
  margin-right: 12px;
  cursor: pointer;
  
  ${mediaqueries.phablet`
    padding-top: 0;
  `};
`;

const AreaMenuPopup = styled.div`
  position: absolute;
  top: 38px;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  background-color: #ffffff;
  border: 1px solid #000000;
`;

const AreasMenuPopupLink = styled.a`
  padding: 4px 16px;
  color: #000000;
  
  &:hover {
    background-color: #e9ecef;
  }
`;
